const apiOrigin = window.location.origin.replace(':3000', ':8080')

export const withoutParams = (path) => path.replace(/\?.*$/, '')

export const dynamic = (path, ...values) => {
  var out = path
  for (const value of values) {
    out = out.replace(/:[a-z]+/i, value)
  }
  return out
}

export const rootPath = '/'

// client-side routes
export const applinksPostsPath = '/applinks/posts'
export const applinksPostLink = '/applinks/posts?id=:id'

export const applinksBeatsPath = '/applinks/beats'
export const applinksBeatLink = '/applinks/beats?id=:id'

export const applinksPublicUserProfilePath = '/applinks/creator'
export const applinksPublicUserProfileLink = '/applinks/creator?id=:id'

export const applinksPlaylistPath = '/applinks/playlist'
export const applinksPlaylistLink = '/applinks/playlist?id=:id'

export const purchaseBoostDeepLink = '/applinks/purchase/boost?item_type=:type&item_id=:id'

export const adminRootPath = '/admin'

export const adminBeatsPath = '/admin/beats'
export const adminBeatsEditPath = '/admin/beats/edit/:beatId'

export const adminPostsPath = '/admin/posts'
export const adminPostEditPath = '/admin/track/edit/:postId'

export const adminPlaylistsPath = '/admin/playlists'
export const adminPlaylistEditPath = '/admin/playlists/edit/:playlistId'

export const adminHashtagsPath = '/admin/hashtags'
export const adminHashtagEditPath = '/admin/hashtag/edit/:hashtagId'

export const adminProjectsPath = '/admin/projects'

export const adminCreatorProfilePath = '/admin/creator/:userId'
export const adminAnalyticsPath = '/admin/analytics'
export const adminSearchPath = '/admin/search'

export const adminDiscoverPath = '/admin/discover/:type'
export const adminDiscoverNewPath = '/admin/discover/:type/new'

export const adminModerationPath = '/admin/moderation'

export const adminBoostListPath = '/admin/boosts'
export const adminConversationPath = '/admin/conversation/:id'

export const producerRootPath = '/producer'
export const producerSignUpPath = '/producer/signup'
export const producerBeatsPath = '/producer/beats'
export const producerBeatsSubmitPath = '/producer/beats/submit'
export const producerBeatsEditPath = '/producer/beats/edit/:beatId'
export const producerTopTracksPath = '/producer/toptracks'
export const producerPlaylistsPath = '/producer/playlists'
export const producerPlaylistsEditPath = '/producer/playlists/edit/:playlistId'
export const producerSubmitPath = '/producer/submit'
export const producerProfileEditPath = '/producer/profile/edit'
export const producerProfilePath = '/producer/profile'
export const producerBeatUploadsMovingToBeatstars = '/producer/beats/beat-uploads-beatstars'
export const producerReportBasePath = '/producer/report'
export const producerReportPath = `${producerReportBasePath}/:type/:id`
export const producerConversationListPath = '/producer/conversations'
export const producerConversationPath = '/producer/conversation/:id'
export const producerNewMessagePath = '/producer/conversations/new-message'

export const producerPurchaseBeatBoostPath = '/producer/purchase/boost/beat/:id'
export const producerBoostsPath = '/producer/boosts'

// server-side routes
export const adminAuthUrl = `${apiOrigin}/user/admin/signin`
export const adminAnalyticsUrl = `${apiOrigin}/analytics/admin`

export const adminSearchBeatsUrl = `${apiOrigin}/search/admin/beats`
export const adminSearchPostsUrl = `${apiOrigin}/search/admin/posts`
export const adminSearchUsersUrl = `${apiOrigin}/search/admin/users`
export const adminSearchPlaylistsUrl = `${apiOrigin}/search/admin/playlists`
export const adminSearchHashtagsUrl = `${apiOrigin}/search/admin/hashtags`

export const adminDiscoverOptionsUrl = `${apiOrigin}/discover/admin/:type/options`
export const adminDiscoverCreateUrl = `${apiOrigin}/discover/admin/:type`
export const adminDiscoverGetUrl = `${apiOrigin}/discover/admin/:type`
export const adminDiscoverSetOrderUrl = `${apiOrigin}/discover/admin/:type`
export const adminDiscoverDeleteUrl = `${apiOrigin}/discover/admin/:type/:id`

export const adminGetBeatUrl = `${apiOrigin}/beats/admin/:beatId`
export const adminListRecentBeatsUrl = `${apiOrigin}/beats/recent`

export const adminBeatTrendingUrl = `${apiOrigin}/beats/admin/trending`
export const adminBeatFeaturedUrl = `${apiOrigin}/beats/admin/featured`
export const adminBeatFeedUrl = `${apiOrigin}/beats/admin/feed`
export const adminBeatNewUrl = `${apiOrigin}/beats/admin/new`
export const adminBeatConvertToPostUrl = `${apiOrigin}/beats/admin/convert_to_post`
export const adminBeatUserUrl = `${apiOrigin}/beats/admin/user`

export const adminBoostListUrl = `${apiOrigin}/boost/admin`
export const adminBoostStatsUrl = `${apiOrigin}/boost/admin/stats`
export const adminBoostUserUrl = `${apiOrigin}/boost/admin/user`

export const adminPostUrl = `${apiOrigin}/post/admin/:postId`
export const adminPostAudioAiDetectUrl = `${apiOrigin}/post/admin/:postId/audio_ai_detect`

export const adminPostTrendingUrl = `${apiOrigin}/post/admin/trending`
export const adminPostFeaturedUrl = `${apiOrigin}/post/admin/featured`
export const adminPostDerankUrl = `${apiOrigin}/post/admin/derank`
export const adminPostFeedUrl = `${apiOrigin}/post/admin/feed`
export const adminPostConvertToBeatUrl = `${apiOrigin}/post/admin/convert_to_beat`
export const adminPostUserUrl = `${apiOrigin}/post/admin/user`
export const adminPostForYouUrl = `${apiOrigin}/post/admin/for_you`

export const adminPlaylistUrl = `${apiOrigin}/playlist/admin/:playlistId`
export const adminPlaylistItemUrl = `${apiOrigin}/playlist/admin/:playlistId/item`
export const adminPlaylistTrendingUrl = `${apiOrigin}/playlist/admin/trending`
export const adminPlaylistFeaturedUrl = `${apiOrigin}/playlist/admin/featured`
export const adminPlaylistUserUrl = `${apiOrigin}/playlist/admin/user`
export const adminPlaylistFeedUrl = `${apiOrigin}/playlist/admin/feed`

export const adminHashtagUrl = `${apiOrigin}/hashtag/admin/:hashtagId`
export const adminHashtagTrendingUrl = `${apiOrigin}/hashtag/feed/admin/trending`

export const adminProjectResolveUrl = `${apiOrigin}/project_snapshot/admin/resolve`

export const adminModerationBlockUrl = `${apiOrigin}/moderation/block`

export const adminPostModerationRecognizeUrl = `${apiOrigin}/moderation/recognize`
export const adminPostModerationRecognizeAllUrl = `${apiOrigin}/moderation/recognize/all`

export const adminModerationRecognizeAuditUrl = `${apiOrigin}/moderation/recognize/audit`
export const adminModerationReportUrl = `${apiOrigin}/moderation/report`
export const adminModerationReportAuditUrl = `${apiOrigin}/moderation/report/audit`
export const adminModerationReportUpdateUrl = `${apiOrigin}/moderation/report/update`
export const adminModerationReportItemUrl = `${apiOrigin}/moderation/report/item`
export const adminModerationReportReasonsUrl = `${apiOrigin}/moderation/report/reasons`

export const adminModerationUserBanUrl = `${apiOrigin}/moderation/ban`

export const adminModerationBlockImageUrl = `${apiOrigin}/moderation/block_image`

export const adminCreatorProfileUrl = `${apiOrigin}/user/admin/creator/profile`

export const commentListByItemUrl = `${apiOrigin}/comment`
export const adminCommentByUserUrl = `${apiOrigin}/comment/admin/:userId`

export const producerSignInUrl = `${apiOrigin}/user/signin`
export const producerSignUpUrl = `${apiOrigin}/user/signup`
export const producerDeleteAccountUrl = `${apiOrigin}/user`
export const producerProfileUrl = `${apiOrigin}/user/profile`
export const producerPublicProfileUrl = `${apiOrigin}/user/public/profile`
export const userSocialLinkTemplatesUrl = `${apiOrigin}/user/social_link_templates`
export const getUrlProfileUrl = `${apiOrigin}/url/profile`
export const blockUserUrl = `${apiOrigin}/user/block`
export const refreshTokenUrl = `${apiOrigin}/user/refresh_token`
export const getMessageSettingsUrl = `${apiOrigin}/user/settings/conversation`

export const getUrlBeatUrl = `${apiOrigin}/url/beat`
export const getUrlPostUrl = `${apiOrigin}/url/post`
export const postBeatsUrl = `${apiOrigin}/beats`
export const getBeatUrl = `${apiOrigin}/beats/:beatId`
export const listBeatsUrl = `${apiOrigin}/beats/listbyid`
export const getBeatsPrivateUserUrl = `${apiOrigin}/beats/private/user`
export const getBeatsPublicUserUrl = `${apiOrigin}/beats/public/user`
export const deleteBeatUrl = `${apiOrigin}/beats`
export const adminPatchBeatUrl = `${apiOrigin}/beats/admin/:beatId`
export const beatsPublicUserUrl = `${apiOrigin}/beats/public/user`

export const conversationListUrl = `${apiOrigin}/conversation`
export const conversationUrl = `${apiOrigin}/conversation/:conversationId`
export const conversationArchiveUrl = `${apiOrigin}/conversation/:conversationId/archive`
export const conversationMessageUrl = `${apiOrigin}/conversation/:conversationId/message`
export const conversationMessageReadUrl = `${apiOrigin}/conversation/:conversationId/message/:messageId/read`
export const conversationCreateUrl = `${apiOrigin}/conversation/dm`

export const postPostUrl = `${apiOrigin}/post`
export const getPostsPrivateUserUrl = `${apiOrigin}/post/private/user`
export const getPostsPublicUserUrl = `${apiOrigin}/post/public/user`
export const getPostsHashtagFeedUrl = `${apiOrigin}/post/hashtag/:hashtagId`
export const getPostUrl = `${apiOrigin}/post/:postId`
export const deletePostUrl = `${apiOrigin}/post`

export const playlistUrl = `${apiOrigin}/playlist/:playlistId`
export const playlistsForUserUrl = `${apiOrigin}/playlist/user/:userId`
export const playlistItemUrl = `${apiOrigin}/playlist/:playlistId/item`

export const searchBeatsUrl = `${apiOrigin}/search/beats`
export const searchPostsUrl = `${apiOrigin}/search/posts`
export const searchUsersUrl = `${apiOrigin}/search/users`

export const genreUrl = `${apiOrigin}/genre`
export const stripePricesUrl = `${apiOrigin}/purchase/stripe/prices`

export const stripeCheckoutSessionUrl = `${apiOrigin}/purchase/stripe/checkout-session`
export const producerBoostListUrl = `${apiOrigin}/boost`

export const adminListConversationsUrl = `${apiOrigin}/conversation/admin`
export const adminConversationListMessagesUrl = `${apiOrigin}/conversation/admin/:id/message`
export const adminGetConversationUrl = `${apiOrigin}/conversation/admin/:id`
